import React from 'react';
import Injury from '../assets/images/icon-injury.svg';

export default () => {
  return <img src={Injury} alt="" />;
};
